/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_YouInputs */

const en_terms_section_2_term_you = /** @type {(inputs: Terms_Section_2_Term_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Client”, “you”, “user”`)
};

const lv_terms_section_2_term_you = /** @type {(inputs: Terms_Section_2_Term_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Klients”, „Jūs”, „lietotājs”`)
};

/**
* | output |
* | --- |
* | "“Client”, “you”, “user”" |
*
* @param {Terms_Section_2_Term_YouInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_you = /** @type {((inputs?: Terms_Section_2_Term_YouInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_YouInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_you(inputs)
	return en_terms_section_2_term_you(inputs)
});